<template>
    <div>
        <form @submit.prevent class="m-form" name="claimantForm">
            <div class="flex-grid flex-grid--reduced-bottom-margin a-form-inputs">
                <div class="flex-grid__item">
                    <control for="claimantName" label="Claimant Name" v-if="showNames">
                        <input autocomplete="off" v-model="name"
                               required
                               name="claimantName"
                               id="claimantName"
                               v-field-control:claimantName.required="{type:'text', rules:'name'}"
                               maxlength="100"
                               type="text">
                        <control-error :show="$error('claimantName')">
                            The claimant name is required and must be a valid name
                        </control-error>
                    </control>
                    <control for="claimant_gender" label="Claimant Gender">
                        <select v-field-control
                                v-model="gender"
                                required
                                name="claimant_gender">
                            <option :value="null" disabled hidden>Please select...</option>
                            <option value="male">Male</option>
                            <option value="female">Female</option>
                        </select>
                        <control-error :show="$error('claimant_gender')">
                            The claimant's gender is required
                        </control-error>
                    </control>
                    <control for="claimant_date_of_birth" label="Claimant Date of Birth">
                        <date-input v-model="dateOfBirth"
                                    :min="minDateOfBirth"
                                    v-field-control:claimant_date_of_birth.required="{type:'date'}"
                        ></date-input>
                        <control-error :show="$error('claimant_date_of_birth')">
                            The claimant's date of birth is required and must be in the format DD/MM/YYYY.
                            Claimant must be at least 16 at date of assumed settlement.
                        </control-error>
                    </control>
                    <typeahead
                            :required=true
                            :label="'Claimant Solicitors'"
                            :error-message="'The claimant solicitor is required and must be a valid name'"
                            :value="claimantSolicitor"
                            :type="'claimant_solicitors'"
                            @update="updateClaimantSolicitors"
                    ></typeahead>
                    <control for="claimaint_reference" label="Claimant Reference">
                        <input autocomplete="off" v-model="claimantReference"
                               v-field-control
                               required
                               class="input"
                               maxlength="100"
                               name="claimaint_reference" type="text">
                        <control-error :show="$error('claimaint_reference')">
                            The claimant reference is required
                        </control-error>
                    </control>
                    <control for="type_of_injury" label="Type of Injury">
                        <select v-field-control
                                v-model="injuryType"
                                required
                                name="type_of_injury">
                            <option :value="null" disabled hidden>Please select...</option>
                            <option value="Accident - EL">Accident - EL</option>
                            <option value="Accident - PL">Accident - PL</option>
                            <option value="Motor">Motor</option>
                            <option value="Other">Other &mdash; Specify Type</option>
                        </select>
                        <control-error :show="$error('type_of_injury')">
                            The claimant's injury type is required
                        </control-error>
                    </control>
                    <control name="injury_type_other" label="Injury Type Other" v-if="injuryType === 'Other'">
                        <input autocomplete="off" type="text"
                               name="injury_type_other"
                               id="injury_type_other"
                               v-field-control
                               required
                               v-model="injuryTypeOther">
                        <control-error :show="$error('injuryTypeOther') || injuryTypeOther === null">
                            The claimant's injury type is required
                        </control-error>
                    </control>
                </div>
                <div class="flex-grid__item flex-grid--space-left">
                    <typeahead
                            :required=true
                            :label="'Defendant Name'"
                            :error-message="'The defendant name is required and must be a valid name'"
                            :value="defendantName"
                            :type="'defendant'"
                            @update="updateDefendant"
                    ></typeahead>
                    <control for="your_reference" label="Your Reference">
                        <input autocomplete="off" v-model="yourReference"
                               v-field-control
                               required
                               name="your_reference"
                               maxlength="30"
                               type="text">
                        <control-error :show="$error('your_reference')">
                            Your reference is required
                        </control-error>
                    </control>
                    <control for="date_of_injury" label="Date of Injury / Accident">
                        <date-input v-model="dateOfInjury"
                                    v-field-control:date_of_injury.required="{type:'date'}"
                        ></date-input>
                        <control-error :show="$error('date_of_injury')">
                            Date of Injury/Accident is required in the format DD/MM/YYYY
                        </control-error>
                        <control-error :show="showDateInjuryInvalid">
                            Date of Injury/Accident cannot be in the future
                        </control-error>
                        <control-error :show="showdateOfInjuryAfterBirth">
                            Date of Injury/Accident must be after the date of birth
                        </control-error>
                    </control>
                    <control for="pre_lit_or_lit" label="Procedural Status">
                        <select name="pre_lit_or_lit" id="pre_lit_or_lit" v-model="preLitOrLit" v-field-control
                                required>
                            <option value="pre-lit">Pre-Litigation</option>
                            <option value="litigated">Litigated</option>
                        </select>
                        <control-error :show="$error('pre_lit_or_lit')">
                            Procedural status is required
                        </control-error>
                    </control>
                    <control for="date_of_service_proceedings" label="Date of Service of Proceedings"
                             v-if="preLitOrLit == 'litigated'">
                        <date-input v-model="dateOfServiceProceedings"
                                    v-field-control:date_of_service_proceedings.required="{type:'date'}"
                        ></date-input>
                        <control-error
                                :show="$error('date_of_service_proceedings') || showServiceOfProceedingsValidationMessage_required">
                            Date of service of proceedings is required in the format DD/MM/YYYY
                        </control-error>
                        <control-error :show="showServiceOfProceedingsValidationMessage_before">
                            Date of service of proceedings must be before the date of assumed settlement
                        </control-error>
                        <control-error :show="showServiceOfProceedingsValidationMessage_9years">
                            Date of service of proceeding cannot be more than 9 years before the date of assumed
                            settlement
                        </control-error>
                    </control>
                    <control for="date_of_assumed_settlement" label="Date of Assumed Settlement">
                        <date-input v-model="dateOfAssumedSettlement"
                                    v-field-control:date_of_assumed_settlement.required="{type:'date'}"
                        ></date-input>
                        <control-error :show="$error('date_of_assumed_settlement')">
                            Date of assumed settlement is required in the format DD/MM/YYYY
                        </control-error>
                        <control-error :show="showDateOfAssumedSettlementValidationMessage_after">
                            Date of assumed settlement must be after the date of injury or accident
                        </control-error>
                        <control-warning :show="dateOfAssumedSettlementInPast">
                            <warning-box modal-name="warning">
                                <svg slot="icon" viewBox="0 0 120 120" class="m-icon m-icon--dark m-icon--small open">
                                    <use xlink:href="#warning"></use>
                                </svg>
                                <span class="c-warning-box__orange">Date of assumed settlement is in the past</span>
                            </warning-box>
                        </control-warning>
                    </control>
                    <control for="discount_rate" label="Discount Rate">
                        <select name="discount_rate" id="discount_rate" v-model="discountRate" v-field-control
                                required>
                            <option :value="-2.0">-2.00%</option>
                            <option :value="-1.5">-1.50%</option>
                            <option :value="-1.0">-1.00%</option>
                            <option :value="-0.75">-0.75%</option>
                            <option :value="-0.5">-0.50%</option>
                            <option :value="-0.25">-0.25%</option>
                            <option :value="0.0">0.00%</option>
                            <option :value="0.5">0.50%</option>
                            <option :value="1.0">1.00%</option>
                            <option :value="1.5">1.50%</option>
                            <option :value="2.0">2.00%</option>
                            <option :value="2.5">2.50%</option>
                            <option :value="3.0">3.00%</option>
                        </select>
                        <control-error :show="$error('discount_rate')">
                            Discount rate is required
                        </control-error>
                    </control>
                </div>
            </div>
            <div class="a-form-inputs flex-grid__item--full">
                <control for="claim_narrative" label="Claim Narrative"
                         tip-text="Provide a brief background to the claim and issues in dispute. This narrative will populate your counter-schedule of loss."
                         tip-icon="info"
                         tip-side="left"
                         tip-width="250"
                         tip-name="claim_narrative"
                >
                    <textarea required
                              rows="4"
                              v-field-control:claim_narrative.required="{type:'text'}"
                              v-model="claimNarrative"
                              name="claim_narrative"
                              class="u-full-width"></textarea>
                    <control-error :show="$error('claim_narrative')">
                        The claim narrative is required
                    </control-error>
                </control>
            </div>
        </form>

        <step-button :prev-valid="false" :next-valid="isValid()"></step-button>
    </div>
</template>

<script type="text/babel">
    import {mapActions, mapGetters} from 'vuex';
    import StepButton from 'components/StepButton.vue';
    import Control from 'components/form/Control.vue';
    import ControlError from 'components/form/control/Error.vue';
    import ControlWarning from 'components/form/control/Warning.vue';
    import FormValidator from 'components/form/validator/mixin';
    import {setStepValid} from 'services/routingMethods';
    import DateInput from 'components/form/control/DateInput.vue';
    import moment from "moment";
    import Icons from 'components/Icons.vue';
    import WarningBox from 'components/modal/WarningBox.vue';
    import Typeahead from "components/Typeahead";

    export default {
        name: 'claim-info',
        computed: {
            ...mapGetters('personal/claimant', [
                'getClaimantValue',
                'getClaimantDetail',
                'getClaimInfo'
            ]),
            ...mapGetters('personal/generalDamages', {
                getValue: 'value',
            }),
            ...mapGetters('user', ['showNames']),
            name: {
                get() {
                    return this.getClaimantValue('name');
                },
                set(value) {
                    this.updateClaimantValue({key: 'name', value});
                }
            },
            gender: {
                get() {
                    return this.getClaimantValue('gender');
                },
                set(value) {
                    this.updateClaimantValue({key: 'gender', value});
                }
            },
            minDateOfBirth: {
                get() {
                    let assumedSettlment = this.getClaimInfo('dateOfAssumedSettlement');

                    if (!assumedSettlment || assumedSettlment === '') {
                        return '';
                    }

                    // set minimum date of birth to 16 years from assumed settlment:
                    return moment(assumedSettlment, 'DD/MM/YYYY').subtract(16, 'y').format('DD/MM/YYYY');
                }
            },
            dateOfBirth: {
                get() {
                    return this.getClaimantValue('dateOfBirth');
                },
                set(value) {
                    this.updateClaimantValue({key: 'dateOfBirth', value});
                }
            },
            claimantSolicitor: {
                get() {
                    return this.getClaimantDetail('claimantSolicitor');
                },
                set(value) {
                    this.updateClaimantDetail({key: 'claimantSolicitor', value});
                }
            },
            claimantReference: {
                get() {
                    return this.getClaimantDetail('claimantReference');
                },
                set(value) {
                    this.updateClaimantDetail({key: 'claimantReference', value});
                }
            },
            yourReference: {
                get() {
                    return this.getClaimantDetail('yourReference');
                },
                set(value) {
                    this.updateClaimantDetail({key: 'yourReference', value});
                }
            },
            claimType: {
                get() {
                    return this.getClaimantDetail('claimType');
                },
                set(value) {
                    this.updateClaimantDetail({key: 'claimType', value});
                }
            },
            defendantName: {
                get() {
                    return this.getClaimantDetail('defendantName');
                },
                set(value) {
                    this.updateClaimantDetail({key: 'defendantName', value});
                }
            },
            injuryType: {
                get() {
                    return this.getClaimantDetail('injuryType');
                },
                set(value) {
                    this.updateClaimantDetail({key: 'injuryType', value});
                }
            },
            injuryTypeOther: {
                get() {
                    return this.getClaimantDetail('injuryTypeOther');
                },
                set(value) {
                    this.updateClaimantDetail({key: 'injuryTypeOther', value});
                }
            },
            claimNarrative: {
                get() {
                    return this.getClaimantDetail('claimNarrative');
                },
                set(value) {
                    this.updateClaimantDetail({key: 'claimNarrative', value});
                }
            },
            preLitOrLit: {
                get() {
                    return this.getClaimInfo('proceduralStatus');
                },
                set(value) {
                    this.updateClaimInfo({key: 'proceduralStatus', value});
                }
            },
            dateOfInjury: {
                get() {
                    return this.getClaimInfo('dateOfInjury');
                },
                set(value) {
                    this.updateClaimInfo({key: 'dateOfInjury', value});
                }
            },
            dateOfServiceProceedings: {
                get() {
                    return this.getClaimInfo('dateOfServiceProceedings');
                },
                set(value) {
                    this.updateClaimInfo({key: 'dateOfServiceProceedings', value});
                }
            },
            dateOfAssumedSettlement: {
                get() {
                    return this.getClaimInfo('dateOfAssumedSettlement');
                },
                set(value) {
                    this.updateClaimInfo({key: 'dateOfAssumedSettlement', value})
                }
            },
            discountRate: {
                get() {
                    return this.getClaimInfo('discountRate');
                },
                set(value) {
                    return this.updateClaimInfo({key: 'discountRate', value});
                }
            },
            showDateInjuryInvalid: {
                get() {
                    if (!this.dateOfInjury) {
                        return false;
                    }

                    if (!moment(this.dateOfInjury, 'DD/MM/YYYY').isValid()) {
                        return false;
                    }

                    return !moment(this.dateOfInjury, 'DD/MM/YYYY').isBefore(moment());
                }
            },
            showdateOfInjuryAfterBirth: {
                get() {
                    if (!this.dateOfInjury || !this.dateOfBirth) {
                        return false;
                    }

                    if (!moment(this.dateOfInjury, 'DD/MM/YYYY').isValid()
                        || !moment(this.dateOfBirth, 'DD/MM/YYYY').isValid()) {
                        return false;
                    }

                    return !moment(this.dateOfInjury, 'DD/MM/YYYY').isAfter(moment(this.dateOfBirth, 'DD/MM/YYYY'));
                }
            },
            showServiceOfProceedingsValidationMessage_required: {
                get() {
                    if (!this.dateOfServiceProceedings || !this.dateOfAssumedSettlement) {
                        return false;
                    }

                    return (
                        !moment(this.dateOfServiceProceedings, 'DD/MM/YYYY').isValid()
                        || !moment(this.dateOfAssumedSettlement, 'DD/MM/YYYY').isValid()
                    );
                }
            },
            showServiceOfProceedingsValidationMessage_9years: {
                get() {
                    if (this.showServiceOfProceedingsValidationMessage_required) {
                        return false;
                    }

                    let mServiceOfProceedings = moment(this.dateOfServiceProceedings, 'DD/MM/YYYY');
                    let mAssumedSettlement = moment(this.dateOfAssumedSettlement, 'DD/MM/YYYY');

                    if (!mServiceOfProceedings.isValid() || !mAssumedSettlement.isValid()) {
                        return false;
                    }

                    return mServiceOfProceedings.diff(mAssumedSettlement, 'years') < -9;
                }
            },
            showServiceOfProceedingsValidationMessage_before: {
                get() {
                    if (this.showServiceOfProceedingsValidationMessage_required) {
                        return false;
                    }

                    let mServiceOfProceedings = moment(this.dateOfServiceProceedings, 'DD/MM/YYYY');
                    let mAssumedSettlement = moment(this.dateOfAssumedSettlement, 'DD/MM/YYYY');

                    if (!mServiceOfProceedings.isValid() || !mAssumedSettlement.isValid()) {
                        return false;
                    }

                    return !mServiceOfProceedings.isBefore(mAssumedSettlement);
                }
            },
            showDateOfAssumedSettlementValidationMessage_after: {
                get() {
                    let mAssumedSettlement = moment(this.dateOfAssumedSettlement, 'DD/MM/YYYY');
                    let mDateOfAccident = moment(this.dateOfInjury, 'DD/MM/YYYY');

                    if (!mAssumedSettlement.isValid() || !mDateOfAccident.isValid()) {
                        return false;
                    }

                    return !mAssumedSettlement.isAfter(mDateOfAccident);
                }
            },
            dateOfAssumedSettlementInPast: {
                get() {
                    let mAssumedSettlement = moment(this.dateOfAssumedSettlement, 'DD/MM/YYYY');

                    if (!mAssumedSettlement.isValid()) {
                        return false;
                    }

                    return mAssumedSettlement.isBefore(moment());
                }
            }
        },
        data() {
            return {valid: false}
        },
        mounted() {
            this.fetchInjuries;
            this.watchers();
        },
        mixins: [FormValidator],
        components: {
            ControlWarning,
            Icons,
            WarningBox,
            StepButton,
            Control,
            ControlError,
            DateInput,
            Typeahead
        },
        watch: {
            ['$form.$valid']() {
                this.updateValid()
            },
            ['showServiceOfProceedingsValidationMessage_required']() {
                this.updateValid()
            },
            ['showServiceOfProceedingsValidationMessage_9years']() {
                this.updateValid()
            },
            ['showServiceOfProceedingsValidationMessage_before']() {
                this.updateValid()
            },
            ['showDateOfAssumedSettlementValidationMessage_after']() {
                this.updateValid()
            },
            ['showDateInjuryInvalid']() {
                this.updateValid()
            },
            ['showdateOfInjuryAfterBirth']() {
                this.updateValid()
            },
        },
        methods: {
            ...mapActions('personal/claimant', [
                'updateClaimantValue',
                'updateClaimantDetail',
                'updateClaimInfo'
            ]),
            ...mapActions('personal/generalDamages', [
                'fetchInjuries',
                'updateValue',
            ]),
            ...mapActions('personal/futureLosses', [
                'updateDiscountFactors',
            ]),
            updateValid() {
                setStepValid(this.isValid());
            },
            isValid() {
                return !!(
                    this.$valid() &&
                    !this.showServiceOfProceedingsValidationMessage_required &&
                    !this.showServiceOfProceedingsValidationMessage_9years &&
                    !this.showServiceOfProceedingsValidationMessage_before &&
                    !this.showDateOfAssumedSettlementValidationMessage_after &&
                    !this.showDateInjuryInvalid &&
                    !this.showdateOfInjuryAfterBirth &&
                    this.defendantName.name !== null &&
                    this.defendantName.name !== '' &&
                    this.claimantSolicitor.name !== null &&
                    this.claimantSolicitor.name !== '');
            },
            updateClaimantSolicitors(value) {
                this.updateClaimantDetail({key: 'claimantSolicitor', value});
                this.updateValid();
            },
            updateDefendant(value) {
                this.updateClaimantDetail({key: 'defendantName', value});
                this.updateValid();
            },
            watchers() {
                // Updates Discount Factors
                this.$watchAll([
                    "dateOfBirth",
                ], (field, value) => {
                    this.updateDiscountFactors();
                });
            },
        },
    }
</script>



// WEBPACK FOOTER //
// ClaimInfo.vue?3c161a3a